import type { Coordinates } from '@/types'

const calculateDistance = (a: Coordinates, b: Coordinates): number =>
  google.maps.geometry.spherical.computeDistanceBetween(a, b) / 1000

export default calculateDistance
